/**
 * Digifiy Product Page Booster v1.3
 * High-converting product page enhancements
 * Updated: Fetches real reviews from AliExpress Reviews API
 */

(function() {
  'use strict';

  var CONFIG = {
    stockMin: 3,
    stockMax: 12,
    viewersMin: 15,
    viewersMax: 47,
    countdownHours: 2,
    socialProofInterval: 15000,
    reviewsApiUrl: 'https://virali.net/alireviews/api/reviews/',
    names: ['Ahmed', 'Sara', 'Mike', 'Emma', 'John', 'Lisa', 'David', 'Maria', 'James', 'Anna', 'Omar', 'Fatima', 'Alex', 'Sophie', 'Ryan', 'Chloe', 'Ali', 'Ayesha', 'Chris', 'Zara'],
    locations: ['New York', 'London', 'Dubai', 'Sydney', 'Toronto', 'Berlin', 'Paris', 'Mumbai', 'Singapore', 'Los Angeles', 'Chicago', 'Manchester', 'Melbourne', 'Karachi', 'Lahore', 'Amsterdam', 'Stockholm', 'Dublin', 'Auckland', 'Cape Town'],
    times: ['just now', '2 mins ago', '5 mins ago', '8 mins ago', '12 mins ago', '15 mins ago', '23 mins ago', '34 mins ago', '45 mins ago', '1 hour ago']
  };

  function rand(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  function randItem(arr) {
    return arr[Math.floor(Math.random() * arr.length)];
  }

  function waitFor(selector, callback, maxAttempts) {
    maxAttempts = maxAttempts || 100;
    var attempts = 0;
    var check = function() {
      var el = document.querySelector(selector);
      if (el) {
        callback(el);
      } else if (++attempts < maxAttempts) {
        requestAnimationFrame(check);
      }
    };
    requestAnimationFrame(check);
  }

  function isProductPage() {
    return window.location.pathname.includes('/products/') ||
           document.querySelector('.product-information, .product-details, [data-product-id]');
  }

  function getProductId() {
    // Method 1: ShopifyAnalytics meta
    if (window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product) {
      return window.ShopifyAnalytics.meta.product.id;
    }
    // Method 2: window.meta
    if (window.meta && window.meta.product) {
      return window.meta.product.id;
    }
    // Method 3: data-product-id attribute
    var el = document.querySelector('[data-product-id]');
    if (el) return el.dataset.productId;
    // Method 4: Parse from page scripts (most reliable fallback)
    var scripts = document.querySelectorAll('script:not([src])');
    for (var i = 0; i < scripts.length; i++) {
      var text = scripts[i].textContent;
      // Look for "product":{"id":9087999082715
      var match = text.match(/"product":\s*\{\s*"id"\s*:\s*(\d+)/);
      if (match) return match[1];
      // Look for productId:9087999082715
      match = text.match(/productId["\s:]+(\d+)/);
      if (match) return match[1];
      // Look for resourceId":9087999082715
      match = text.match(/resourceId["\s:]+(\d+)/);
      if (match) return match[1];
    }
    // Method 5: Check meta tags
    var productMeta = document.querySelector('meta[property="og:url"]');
    if (productMeta) {
      var urlMatch = productMeta.content.match(/\/products\/([^\/\?]+)/);
      if (urlMatch) return urlMatch[1]; // Returns handle, API accepts both
    }
    return null;
  }

  function getProductInfo() {
    var title = document.querySelector('.product__title, .product-title, h1.title, [data-product-title]');
    var price = document.querySelector('.price-item--regular, .product__price, .price .money, [data-product-price]');
    var image = document.querySelector('.product__media img, .product-featured-image, [data-product-featured-image]');

    return {
      title: title ? title.textContent.trim() : 'This Product',
      price: price ? price.textContent.trim() : '',
      image: image ? image.src : ''
    };
  }

  // URGENCY BAR
  function createUrgencyBar() {
    var stock = rand(CONFIG.stockMin, CONFIG.stockMax);
    return '<div class="digifiy-urgency-bar"><span class="fire-icon">🚚</span><span class="digifiy-stock-dot"></span><span>Free Shipping! Only <strong>' + stock + ' left</strong> - Buy 2 Get 20% Additional Off</span></div>';
  }

  // LIVE VIEWERS
  function createViewersCounter() {
    var viewers = rand(CONFIG.viewersMin, CONFIG.viewersMax);
    return '<div class="digifiy-viewers"><span class="eye-icon">👁️</span><span class="digifiy-viewers-dot"></span><span><span class="digifiy-viewers-count">' + viewers + '</span> people viewing this right now</span></div>';
  }

  function updateViewers() {
    var el = document.querySelector('.digifiy-viewers-count');
    if (el) {
      var current = parseInt(el.textContent);
      var change = rand(-3, 5);
      var newCount = Math.max(CONFIG.viewersMin, Math.min(CONFIG.viewersMax + 10, current + change));
      el.textContent = newCount;
    }
  }

  // COUNTDOWN TIMER
  function createCountdown() {
    return '<div class="digifiy-countdown"><div class="digifiy-countdown-label">⚡ Flash Sale Ends In</div><div class="digifiy-countdown-timer"><div class="digifiy-countdown-block"><span class="digifiy-countdown-number" id="countdown-hours">02</span><span class="digifiy-countdown-unit">Hours</span></div><div class="digifiy-countdown-block"><span class="digifiy-countdown-number" id="countdown-mins">00</span><span class="digifiy-countdown-unit">Mins</span></div><div class="digifiy-countdown-block"><span class="digifiy-countdown-number" id="countdown-secs">00</span><span class="digifiy-countdown-unit">Secs</span></div></div></div>';
  }

  function updateCountdown() {
    var endTime = sessionStorage.getItem('digifiy_countdown_end');
    if (!endTime) {
      endTime = Date.now() + (CONFIG.countdownHours * 60 * 60 * 1000);
      sessionStorage.setItem('digifiy_countdown_end', endTime);
    }

    var now = Date.now();
    var diff = parseInt(endTime) - now;

    if (diff <= 0) {
      endTime = Date.now() + (CONFIG.countdownHours * 60 * 60 * 1000);
      sessionStorage.setItem('digifiy_countdown_end', endTime);
      diff = parseInt(endTime) - now;
    }

    var hours = Math.floor(diff / (1000 * 60 * 60));
    var mins = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
    var secs = Math.floor((diff % (1000 * 60)) / 1000);

    var hoursEl = document.getElementById('countdown-hours');
    var minsEl = document.getElementById('countdown-mins');
    var secsEl = document.getElementById('countdown-secs');

    if (hoursEl) hoursEl.textContent = hours.toString().padStart(2, '0');
    if (minsEl) minsEl.textContent = mins.toString().padStart(2, '0');
    if (secsEl) secsEl.textContent = secs.toString().padStart(2, '0');
  }

  // TRUST BADGES (Free Shipping removed)
  function createTrustBadges() {
    return '<div class="digifiy-trust-badges"><div class="digifiy-trust-badge"><span class="digifiy-trust-badge-icon">🔒</span><span class="digifiy-trust-badge-text">Secure Payment</span></div><div class="digifiy-trust-badge"><span class="digifiy-trust-badge-icon">↩️</span><span class="digifiy-trust-badge-text">30-Day Returns</span></div><div class="digifiy-trust-badge"><span class="digifiy-trust-badge-icon">✅</span><span class="digifiy-trust-badge-text">Quality Guarantee</span></div></div>';
  }

  // BENEFITS
  function createBenefits() {
    return '<ul class="digifiy-benefits"><li class="digifiy-benefit"><span class="digifiy-benefit-icon">✓</span><span>Premium quality materials & craftsmanship</span></li><li class="digifiy-benefit"><span class="digifiy-benefit-icon">✓</span><span>Fast & tracked worldwide shipping</span></li><li class="digifiy-benefit"><span class="digifiy-benefit-icon">✓</span><span>24/7 customer support</span></li><li class="digifiy-benefit"><span class="digifiy-benefit-icon">✓</span><span>Hassle-free returns within 30 days</span></li></ul>';
  }

  // GUARANTEE
  function createGuarantee() {
    return '<div class="digifiy-guarantee"><span class="digifiy-guarantee-icon">🛡️</span><div class="digifiy-guarantee-content"><div class="digifiy-guarantee-title">100% Satisfaction Guarantee</div><div class="digifiy-guarantee-text">Not satisfied? Get a full refund within 30 days. No questions asked.</div></div></div>';
  }

  // BULK DISCOUNT CARD (disabled)
  function createBulkDiscount() {
    return '';
  }

  // PAYMENT ICONS
  function createPaymentIcons() {
    return '<div class="digifiy-payment-icons"><span class="digifiy-pay-item"><svg viewBox="0 0 50 32" width="38" height="24"><rect width="50" height="32" rx="4" fill="#1A1F71"/><text x="25" y="20" font-size="12" fill="#fff" text-anchor="middle" font-weight="bold">VISA</text></svg></span><span class="digifiy-pay-item"><svg viewBox="0 0 50 32" width="38" height="24"><rect width="50" height="32" rx="4" fill="#fff" stroke="#ddd"/><circle cx="20" cy="16" r="10" fill="#EB001B"/><circle cx="30" cy="16" r="10" fill="#F79E1B"/><path d="M25 8a10 10 0 000 16 10 10 0 000-16" fill="#FF5F00"/></svg></span><span class="digifiy-pay-item"><svg viewBox="0 0 50 32" width="38" height="24"><rect width="50" height="32" rx="4" fill="#006FCF"/><text x="25" y="20" font-size="9" fill="#fff" text-anchor="middle" font-weight="bold">AMEX</text></svg></span><span class="digifiy-pay-item"><svg viewBox="0 0 50 32" width="38" height="24"><rect width="50" height="32" rx="4" fill="#003087"/><text x="25" y="20" font-size="9" fill="#fff" text-anchor="middle" font-weight="bold">PayPal</text></svg></span><span class="digifiy-pay-item"><svg viewBox="0 0 50 32" width="38" height="24"><rect width="50" height="32" rx="4" fill="#000"/><text x="25" y="20" font-size="8" fill="#fff" text-anchor="middle" font-weight="bold">Apple Pay</text></svg></span></div>';
  }

  // STICKY CART
  function createStickyCart() {
    var product = getProductInfo();
    return '<div class="digifiy-sticky-cart" id="digifiy-sticky-cart"><div class="digifiy-sticky-cart-info">' + (product.image ? '<img src="' + product.image + '" alt="" class="digifiy-sticky-cart-img">' : '') + '<div class="digifiy-sticky-cart-details"><div class="digifiy-sticky-cart-title">' + product.title + '</div><div class="digifiy-sticky-cart-price">' + product.price + '</div></div></div><button class="digifiy-sticky-cart-btn" onclick="(document.querySelector(\'[id^=ProductSubmitButton-], form[action$=add] [name=add]\')||document.querySelector(\'[name=add]\')).click()">🛒 Add to Cart</button></div>';
  }

  function handleStickyCart() {
    var sticky = document.getElementById('digifiy-sticky-cart');
    var addToCartBtn = document.querySelector('[name=add], .product-form__submit, .add-to-cart');

    if (!sticky || !addToCartBtn) return;

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          sticky.classList.remove('visible');
        } else {
          sticky.classList.add('visible');
        }
      });
    }, { threshold: 0 });

    observer.observe(addToCartBtn);
  }

  // SOCIAL PROOF
  function createSocialProof() {
    return '<div class="digifiy-social-proof" id="digifiy-social-proof"><img src="" alt="" class="digifiy-social-proof-img" id="social-proof-img"><div class="digifiy-social-proof-content"><div class="digifiy-social-proof-name" id="social-proof-name"></div><div class="digifiy-social-proof-action" id="social-proof-action"></div><div class="digifiy-social-proof-time" id="social-proof-time"></div></div><button class="digifiy-social-proof-close" onclick="this.parentElement.classList.remove(\'visible\')">×</button></div>';
  }

  function showSocialProof() {
    var popup = document.getElementById('digifiy-social-proof');
    var nameEl = document.getElementById('social-proof-name');
    var actionEl = document.getElementById('social-proof-action');
    var timeEl = document.getElementById('social-proof-time');
    var imgEl = document.getElementById('social-proof-img');

    if (!popup) return;

    var products = document.querySelectorAll('.card-product, .product-card, [data-product-card]');
    var product = products.length > 0 ? products[rand(0, products.length - 1)] : null;
    var productImg = product ? product.querySelector('img') : null;
    var productTitle = product ? (product.querySelector('.card-product__title, .product-title, h3') || {}).textContent : getProductInfo().title;

    var name = randItem(CONFIG.names);
    var location = randItem(CONFIG.locations);
    var time = randItem(CONFIG.times);

    nameEl.textContent = name + ' from ' + location;
    actionEl.textContent = 'purchased ' + (productTitle || 'a product').substring(0, 30) + (productTitle && productTitle.length > 30 ? '...' : '');
    timeEl.textContent = time;

    if (productImg) {
      imgEl.src = productImg.src;
      imgEl.style.display = 'block';
    } else if (getProductInfo().image) {
      imgEl.src = getProductInfo().image;
      imgEl.style.display = 'block';
    } else {
      imgEl.style.display = 'none';
    }

    popup.classList.add('visible');
    setTimeout(function() { popup.classList.remove('visible'); }, 5000);
  }

  // REVIEWS SUMMARY - will be updated with real data
  function createReviewsSummary(rating, count) {
    rating = rating || 4.9;
    count = count || 0;
    var stars = '★★★★★'.substring(0, Math.round(rating)) + '☆☆☆☆☆'.substring(0, 5 - Math.round(rating));
    return '<div class="digifiy-reviews-summary"><span class="digifiy-stars">' + stars + '</span><span class="digifiy-rating-text">' + rating.toFixed(1) + ' rating based on <span class="digifiy-rating-count">' + count + ' reviews</span></span></div>';
  }

  // Fetch real reviews from API
  function fetchRealReviews(productId, callback) {
    var xhr = new XMLHttpRequest();
    xhr.open('GET', CONFIG.reviewsApiUrl + productId, true);
    xhr.onreadystatechange = function() {
      if (xhr.readyState === 4) {
        if (xhr.status === 200) {
          try {
            var data = JSON.parse(xhr.responseText);
            callback(data);
          } catch (e) {
            console.log('[Digifiy] Failed to parse reviews:', e);
            callback({ reviews: [], stats: {} });
          }
        } else {
          callback({ reviews: [], stats: {} });
        }
      }
    };
    xhr.send();
  }

  // Format date nicely
  function formatReviewDate(dateStr) {
    try {
      var date = new Date(dateStr);
      var now = new Date();
      var diff = now - date;
      var days = Math.floor(diff / (1000 * 60 * 60 * 24));
      if (days === 0) return 'Today';
      if (days === 1) return 'Yesterday';
      if (days < 7) return days + ' days ago';
      if (days < 30) return Math.floor(days / 7) + ' weeks ago';
      if (days < 365) return Math.floor(days / 30) + ' months ago';
      return date.toLocaleDateString();
    } catch (e) {
      return dateStr;
    }
  }

  // Reviews pagination state
  var STOREFRONT_PER_PAGE = 10;
  var storefrontReviews = [];
  var storefrontPage = 1;

  function renderReviewItem(r) {
    var stars = '';
    for (var i = 1; i <= 5; i++) {
      stars += i <= r.rating ? '★' : '☆';
    }
    var images = '';
    if (r.images && r.images.length > 0) {
      images = '<div class="digifiy-review-images">' + r.images.slice(0, 3).map(function(img) {
        return '<img src="' + img + '" alt="Review" class="digifiy-review-img" onclick="window.digifiyOpenImage(\'' + img + '\')" onerror="this.style.display=\'none\'">';
      }).join('') + (r.images.length > 3 ? '<span class="digifiy-more-images">+' + (r.images.length - 3) + '</span>' : '') + '</div>';
    }
    return '<div class="digifiy-review-item">' +
      '<div class="digifiy-review-header">' +
        '<div class="digifiy-review-avatar">' + (r.name || 'B').charAt(0).toUpperCase() + '</div>' +
        '<div class="digifiy-review-meta">' +
          '<div class="digifiy-review-name">' + (r.name || 'Verified Buyer') + '</div>' +
          '<div class="digifiy-review-date">' + formatReviewDate(r.date || r.created_at) + '</div>' +
        '</div>' +
        '<div class="digifiy-review-rating">' + stars + '</div>' +
        '<span class="digifiy-review-verified">✓ Verified Purchase</span>' +
      '</div>' +
      (r.body ? '<div class="digifiy-review-text">' + r.body + '</div>' : '') +
      images +
      (r.sku ? '<div class="digifiy-review-sku">' + r.sku + '</div>' : '') +
    '</div>';
  }

  function renderStorefrontReviewsPage() {
    var container = document.querySelector('.digifiy-reviews-list');
    if (!container) return;

    var total = storefrontReviews.length;
    if (total === 0) {
      container.innerHTML = '<div class="digifiy-no-reviews">No reviews yet. Be the first to review this product!</div>';
      return;
    }

    var totalPages = Math.ceil(total / STOREFRONT_PER_PAGE);
    if (storefrontPage > totalPages) storefrontPage = totalPages;
    if (storefrontPage < 1) storefrontPage = 1;
    var start = (storefrontPage - 1) * STOREFRONT_PER_PAGE;
    var end = Math.min(start + STOREFRONT_PER_PAGE, total);
    var pageReviews = storefrontReviews.slice(start, end);

    var html = pageReviews.map(renderReviewItem).join('');

    // Pagination controls
    if (totalPages > 1) {
      html += '<div class="digifiy-pagination">';
      html += '<button class="digifiy-page-btn" onclick="window.digifiyGoPage(' + (storefrontPage - 1) + ')"' + (storefrontPage === 1 ? ' disabled' : '') + '>&lsaquo; Prev</button>';
      for (var i = 1; i <= totalPages; i++) {
        if (totalPages <= 7 || i === 1 || i === totalPages || Math.abs(i - storefrontPage) <= 1) {
          html += '<button class="digifiy-page-btn' + (i === storefrontPage ? ' active' : '') + '" onclick="window.digifiyGoPage(' + i + ')">' + i + '</button>';
        } else if (i === 2 && storefrontPage > 4 || i === totalPages - 1 && storefrontPage < totalPages - 3) {
          html += '<span class="digifiy-page-dots">...</span>';
        }
      }
      html += '<button class="digifiy-page-btn" onclick="window.digifiyGoPage(' + (storefrontPage + 1) + ')"' + (storefrontPage === totalPages ? ' disabled' : '') + '>Next &rsaquo;</button>';
      html += '<span class="digifiy-page-info">' + (start + 1) + '-' + end + ' of ' + total + '</span>';
      html += '</div>';
    }

    container.innerHTML = html;
  }

  // Global page navigation
  window.digifiyGoPage = function(page) {
    var totalPages = Math.ceil(storefrontReviews.length / STOREFRONT_PER_PAGE);
    if (page < 1 || page > totalPages) return;
    storefrontPage = page;
    renderStorefrontReviewsPage();
    // Scroll to reviews section
    var reviewsTab = document.getElementById('tab-reviews');
    if (reviewsTab) reviewsTab.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  // PROFESSIONAL TABS with REAL reviews
  function createProductTabs(description, reviews, stats, overrideCount) {
    reviews = reviews || [];
    stats = stats || {};
    storefrontReviews = reviews;
    storefrontPage = 1;

    var rating = stats.avgRating || (reviews.length > 0 ? reviews.reduce(function(s, r) { return s + (r.rating || 5); }, 0) / reviews.length : 4.9);
    var reviewCount = overrideCount || reviews.length;
    var dist = stats.ratingDistribution || {};

    // Rating bars - scale counts proportionally if overrideCount is used
    var barsHtml = '';
    var actualTotal = 0;
    for (var j = 1; j <= 5; j++) actualTotal += (dist[j] || 0);
    var scale = actualTotal > 0 && reviewCount > actualTotal ? reviewCount / actualTotal : 1;
    for (var i = 5; i >= 1; i--) {
      var rawCount = dist[i] || 0;
      var scaledCount = Math.round(rawCount * scale);
      var pct = actualTotal > 0 ? (rawCount / actualTotal * 100) : 0;
      barsHtml += '<div class="digifiy-rating-bar"><span class="digifiy-bar-label">' + i + ' ★</span><div class="digifiy-bar-track"><div class="digifiy-bar-fill" style="width:' + pct + '%"></div></div><span class="digifiy-bar-count">' + scaledCount + '</span></div>';
    }

    return '<div class="digifiy-tabs-container">' +
      '<div class="digifiy-tabs-header">' +
        '<button class="digifiy-tab-btn active" data-tab="description"><span class="tab-icon">📋</span>Description</button>' +
        '<button class="digifiy-tab-btn" data-tab="reviews"><span class="tab-icon">⭐</span>Reviews (' + reviewCount + ')</button>' +
        '<button class="digifiy-tab-btn" data-tab="shipping"><span class="tab-icon">🚚</span>Shipping</button>' +
      '</div>' +
      '<div class="digifiy-tab-content active" id="tab-description">' +
        '<div class="digifiy-description">' + description + '</div>' +
      '</div>' +
      '<div class="digifiy-tab-content" id="tab-reviews">' +
        '<div class="digifiy-reviews-header">' +
          '<div class="digifiy-reviews-avg">' +
            '<div class="digifiy-reviews-score">' + rating.toFixed(1) + '</div>' +
            '<div>' +
              '<div class="digifiy-reviews-stars">★★★★★</div>' +
              '<div class="digifiy-reviews-count">Based on ' + reviewCount + ' reviews</div>' +
            '</div>' +
          '</div>' +
          '<div class="digifiy-rating-bars">' + barsHtml + '</div>' +
        '</div>' +
        '<div class="digifiy-reviews-list"></div>' +
      '</div>' +
      '<div class="digifiy-tab-content" id="tab-shipping">' +
        '<div class="digifiy-description">' +
          '<h3>🚚 Free Worldwide Shipping</h3>' +
          '<p>We offer free standard shipping on all orders worldwide!</p>' +
          '<h3>⏱️ Processing Time</h3>' +
          '<p><strong>1-2 business days</strong> - Orders are processed and shipped quickly from our warehouse.</p>' +
          '<h3>📦 Shipping Time</h3>' +
          '<ul>' +
            '<li><strong>USA:</strong> 2-7 business days</li>' +
            '<li><strong>Canada:</strong> 2-7 business days</li>' +
            '<li><strong>UK & Europe:</strong> 2-7 business days</li>' +
            '<li><strong>Australia:</strong> 2-7 business days</li>' +
            '<li><strong>Rest of World:</strong> 2-7 business days</li>' +
          '</ul>' +
          '<h3>📍 Order Tracking</h3>' +
          '<p>Once your order ships, you\'ll receive a tracking number via email to monitor your package\'s journey.</p>' +
        '</div>' +
      '</div>' +
    '</div>';
  }

  function initTabs() {
    document.querySelectorAll('.digifiy-tab-btn').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var tabId = this.getAttribute('data-tab');
        document.querySelectorAll('.digifiy-tab-btn').forEach(function(b) { b.classList.remove('active'); });
        document.querySelectorAll('.digifiy-tab-content').forEach(function(c) { c.classList.remove('active'); });
        this.classList.add('active');
        document.getElementById('tab-' + tabId).classList.add('active');
      });
    });
  }

  // ============================================
  // FAKE REVIEWS SYSTEM for 0-review products
  // ============================================

  // Seeded random: same product ID always gives same results
  function hashProductId(pid) {
    var str = String(pid);
    var hash = 0;
    for (var i = 0; i < str.length; i++) {
      hash = ((hash << 5) - hash) + str.charCodeAt(i);
      hash = hash & hash; // Convert to 32bit int
    }
    return Math.abs(hash);
  }

  function seededRandom(seed, index) {
    var x = Math.sin(seed + index) * 10000;
    return x - Math.floor(x);
  }

  // 5 sets of 10 generic reviews each
  var FAKE_REVIEW_SETS = [
    // Set 0: General satisfaction
    [
      { name: 'Sarah M.', rating: 5, body: 'Absolutely love this! The quality is outstanding and it arrived faster than I expected. I\'ve been using it daily and it still looks brand new. Would definitely recommend to anyone thinking about getting one.' },
      { name: 'James K.', rating: 5, body: 'This exceeded all my expectations. The build quality is solid and it works exactly as described. I was a bit skeptical ordering online but I\'m so glad I did. Already ordered another one for my sister.' },
      { name: 'Emily R.', rating: 4, body: 'Great product overall. It does exactly what it\'s supposed to do and the quality feels premium. Shipping was fast too. Only reason for 4 stars is I wish there were more color options available.' },
      { name: 'Michael T.', rating: 5, body: 'Perfect! I\'ve compared this to similar products from other brands and this one wins by far. The attention to detail is impressive and the packaging was really nice too. Very satisfied with my purchase.' },
      { name: 'Rachel L.', rating: 5, body: 'I bought this after reading other reviews and I\'m not disappointed. It\'s well-made, looks great, and functions perfectly. My friends keep asking me where I got it from. Highly recommend!' },
      { name: 'David W.', rating: 4, body: 'Really happy with this purchase. The quality is much better than what I expected at this price point. It arrived well-packaged and in perfect condition. Would buy from this store again.' },
      { name: 'Jennifer H.', rating: 5, body: 'Just wow! This is exactly what I was looking for. The craftsmanship is excellent and you can tell a lot of thought went into the design. It\'s become one of my favorite purchases this year.' },
      { name: 'Daniel P.', rating: 5, body: 'Bought this as a gift for my wife and she absolutely loves it. The quality exceeded our expectations. Fast shipping and great customer service when I had a question. Five stars all the way.' },
      { name: 'Laura S.', rating: 4, body: 'Very nice product. Good quality materials and it looks even better in person than in the photos. Delivery took a few days but it was worth the wait. Would recommend to friends and family.' },
      { name: 'Chris B.', rating: 5, body: 'Outstanding quality for the price! I was hesitant at first but this turned out to be one of the best purchases I\'ve made online. Works flawlessly and looks amazing. Already recommending it to everyone.' }
    ],
    // Set 1: Gift & value theme
    [
      { name: 'Amanda C.', rating: 5, body: 'Purchased this as a birthday gift and the recipient was thrilled! The quality is top-notch and the packaging made it feel really special. Couldn\'t be happier with this choice.' },
      { name: 'Robert J.', rating: 5, body: 'Amazing value for money. I\'ve seen similar items at twice the price that don\'t even come close to this quality. Shipping was quick and the product was exactly as described. Very impressed.' },
      { name: 'Sofia N.', rating: 4, body: 'Really good product! I did a lot of research before buying and I\'m glad I chose this one. It looks beautiful, feels sturdy, and works perfectly. Minor packaging issue but the product itself is great.' },
      { name: 'Thomas A.', rating: 5, body: 'Got this for my mom and she absolutely adores it. The quality is fantastic and it looks much more expensive than it actually is. Will definitely be coming back to buy more gifts from here.' },
      { name: 'Olivia F.', rating: 5, body: 'So glad I found this! I\'ve been searching for something like this for months and nothing else compared. It arrived in perfect condition and works beautifully. My new favorite thing.' },
      { name: 'Mark D.', rating: 4, body: 'Solid purchase. The product quality is very good and it looks exactly like the pictures. I appreciate the fast shipping and careful packaging. Would have given 5 stars if shipping was a day faster.' },
      { name: 'Jessica G.', rating: 5, body: 'This is my second purchase from this store and once again I\'m blown away by the quality. Everything about this product is perfect - the materials, the finish, the functionality. Love it!' },
      { name: 'Andrew V.', rating: 5, body: 'Can\'t say enough good things about this. The quality is exceptional and it performs even better than advertised. My whole family loves it. Best online purchase I\'ve made in a long time.' },
      { name: 'Nicole E.', rating: 5, body: 'Absolutely beautiful! The photos don\'t do it justice - it looks even better in person. I\'ve been using it every day since it arrived and it still looks and works like new. Highly recommend!' },
      { name: 'Kevin Z.', rating: 4, body: 'Very pleased with this product. It\'s well-designed, functional, and made with quality materials. The price is very reasonable for what you get. Would definitely recommend to anyone looking for one.' }
    ],
    // Set 2: Quality & durability theme
    [
      { name: 'Michelle W.', rating: 5, body: 'The quality of this product is incredible. You can immediately tell it\'s well-made from the moment you open the package. I\'ve been using it for weeks now and it\'s holding up beautifully. Worth every penny.' },
      { name: 'Brandon T.', rating: 5, body: 'Fantastic product! Everything from the packaging to the product itself screams quality. It works flawlessly and looks great. I\'m seriously impressed and will be ordering more for friends.' },
      { name: 'Hannah L.', rating: 4, body: 'Really love this! It\'s exactly what I needed and the quality is better than I expected. The design is sleek and modern. Only giving 4 stars because I wish it came in more sizes.' },
      { name: 'William R.', rating: 5, body: 'I\'ve bought similar products before and this is hands down the best one. Superior quality, great design, and it actually works as described. Don\'t hesitate - just buy it. You won\'t regret it.' },
      { name: 'Ashley K.', rating: 5, body: 'So impressed with this purchase! It arrived quickly, was beautifully packaged, and the product quality is amazing. It\'s become a daily essential for me now. Thank you for making such a great product.' },
      { name: 'Ryan M.', rating: 4, body: 'Good quality product that does exactly what it promises. The materials feel durable and well-chosen. Happy with my purchase and would recommend it. Fast delivery too which was a nice bonus.' },
      { name: 'Stephanie H.', rating: 5, body: 'This is exactly what I\'ve been looking for! The quality is superb and the attention to detail is remarkable. I showed it to my coworkers and now three of them want to order one too.' },
      { name: 'Jason P.', rating: 5, body: 'Bought this on a whim and it turned out to be one of my best purchases. The craftsmanship is excellent, it looks premium, and it performs perfectly. Exceeded my expectations in every way.' },
      { name: 'Catherine D.', rating: 5, body: 'I\'m extremely satisfied with this product. The quality is outstanding for the price and it functions perfectly. Customer service was also very helpful when I had a question. Highly recommend!' },
      { name: 'Patrick O.', rating: 4, body: 'Great product overall. Well-built, nice design, and works perfectly. The shipping was reasonably fast and the packaging kept everything safe. I\'d definitely buy from this seller again.' }
    ],
    // Set 3: Everyday use theme
    [
      { name: 'Maria V.', rating: 5, body: 'I use this every single day and it never disappoints. The quality is amazing and it still looks brand new after weeks of use. Shipping was fast and the packaging was secure. Best purchase in a long time.' },
      { name: 'Steven B.', rating: 5, body: 'Perfect product, exactly as described. The quality blew me away - it feels so premium. I ordered it for myself but now I\'m buying more as gifts. Everyone I show it to wants one.' },
      { name: 'Lisa Q.', rating: 4, body: 'Really happy with my purchase! It works great and the quality is solid. Arrived in good condition and looks just like the photos. The only minor thing is I wish it came with a carrying case.' },
      { name: 'Nathan F.', rating: 5, body: 'Just received mine and I\'m already in love with it! The build quality is exceptional and it works perfectly out of the box. No complaints at all. This store has a customer for life.' },
      { name: 'Diana C.', rating: 5, body: 'Ordered this for myself after seeing a friend\'s and I\'m so glad I did. The quality is just as good as much more expensive alternatives. Fast shipping, great packaging, amazing product.' },
      { name: 'George A.', rating: 4, body: 'A very good product at a fair price. It performs well and seems durable. I\'ve been using it regularly and haven\'t had any issues. Would recommend to anyone who needs one of these.' },
      { name: 'Rebecca S.', rating: 5, body: 'This product is simply amazing! Beautiful design, high-quality materials, and it works flawlessly. I\'ve received so many compliments already. Don\'t overthink it - just order it!' },
      { name: 'Eric J.', rating: 5, body: 'Exceeded my expectations by far! I read all the reviews before ordering and they were spot on. This is a high-quality product that delivers exactly what it promises. Very satisfied customer here.' },
      { name: 'Samantha N.', rating: 5, body: 'I compared several options before settling on this one and I made the right choice. Excellent quality, beautiful design, and fast delivery. It\'s become an essential part of my daily routine.' },
      { name: 'Alex H.', rating: 4, body: 'Solid product that works well. The quality is noticeably better than cheaper alternatives I\'ve tried. Arrived quickly and well-packaged. Happy with my decision to buy this.' }
    ],
    // Set 4: Recommendation theme
    [
      { name: 'Victoria L.', rating: 5, body: 'I can\'t recommend this enough! The quality is phenomenal and it works even better than I hoped. My neighbor saw it and immediately ordered one for herself. That says it all!' },
      { name: 'Matthew G.', rating: 5, body: 'Five stars without hesitation. This product is well-made, beautifully designed, and does exactly what it should. The fast shipping was a bonus. I\'ll definitely be a repeat customer.' },
      { name: 'Karen Y.', rating: 4, body: 'Very nice product. I appreciate the quality of the materials and the thoughtful design. It arrived on time and in perfect condition. Would give 5 stars but packaging could be slightly better.' },
      { name: 'Brian W.', rating: 5, body: 'This is the real deal. After being disappointed by similar products from other sellers, this one completely restored my faith. Outstanding quality, fast shipping, and it works perfectly.' },
      { name: 'Angela M.', rating: 5, body: 'Bought this for our home and it\'s been wonderful. The quality is superb and it looks fantastic. My husband was skeptical about ordering online but even he admits this is an excellent product.' },
      { name: 'Tyler R.', rating: 5, body: 'I\'m blown away by the quality of this product. It\'s clear that a lot of care goes into making these. It arrived fast, was packed securely, and looks even better than the photos. Highly recommend!' },
      { name: 'Megan E.', rating: 4, body: 'Really good product for the price! It does everything I needed and the quality seems durable. I\'ve been using it for a couple of weeks now and I\'m still very happy with it.' },
      { name: 'Carlos P.', rating: 5, body: 'This product is absolutely worth it. The quality is exceptional and the design is exactly what I wanted. I\'ve already recommended it to all my friends. You won\'t be disappointed!' },
      { name: 'Heather F.', rating: 5, body: 'So happy with my order! The product quality far exceeded my expectations. It arrived quickly and was exactly as described. This has become one of my most-used items. Truly a great find.' },
      { name: 'Jonathan D.', rating: 4, body: 'Great product, well-made, and works as advertised. I did a lot of comparison shopping and this offered the best combination of quality and price. Would definitely purchase again.' }
    ]
  ];

  // Generate fake review dates (seeded, recent-looking)
  function generateFakeDate(seed, index) {
    var daysAgo = Math.floor(seededRandom(seed, index + 100) * 60) + 3; // 3 to 63 days ago
    var date = new Date();
    date.setDate(date.getDate() - daysAgo);
    return date.toISOString().split('T')[0];
  }

  // Get fake data for a 0-review product
  function getFakeReviewData(productId) {
    var hash = hashProductId(productId);
    var setIndex = hash % FAKE_REVIEW_SETS.length; // which set (0-4)
    var ratingOptions = [4.7, 4.8, 4.9];
    var fakeRating = ratingOptions[hash % ratingOptions.length];
    var fakeCount = 35 + (hash % 51); // 35 to 85

    var reviews = FAKE_REVIEW_SETS[setIndex].map(function(r, i) {
      return {
        name: r.name,
        rating: r.rating,
        body: r.body,
        date: generateFakeDate(hash, i),
        source: 'generic',
        verified: true,
        images: []
      };
    });

    // Build stats
    var dist = {};
    reviews.forEach(function(r) { dist[r.rating] = (dist[r.rating] || 0) + 1; });

    return {
      reviews: reviews,
      stats: {
        avgRating: fakeRating,
        ratingDistribution: dist
      },
      fakeCount: fakeCount // displayed count (higher than 10 shown)
    };
  }

  // Update the Liquid "Customer Reviews" header section
  function updateLiquidReviewsHeader(avgRating, displayCount, reviews) {
    // Wait for the Liquid inline script to render the header first
    var attempts = 0;
    var interval = setInterval(function() {
      attempts++;
      var avgEl = document.getElementById('alireviews-avg-rating');
      if (!avgEl && attempts < 50) return; // wait up to 5 seconds
      clearInterval(interval);
      if (!avgEl) return;

      // Update average rating
      avgEl.textContent = avgRating.toFixed(1);

      // Update stars display
      var starsEl = document.getElementById('alireviews-stars');
      if (starsEl) {
        var fullStars = Math.floor(avgRating);
        var halfStar = (avgRating - fullStars) >= 0.3;
        var starsStr = '';
        for (var i = 0; i < 5; i++) {
          if (i < fullStars) starsStr += '\u2605';
          else if (i === fullStars && halfStar) starsStr += '\u2605\u00BD'.charAt(0); // use full star for half
          else starsStr += '\u2606';
        }
        starsEl.textContent = starsStr;
        starsEl.style.color = '#f59e0b';
      }

      // Update count
      var countEl = document.getElementById('alireviews-count');
      if (countEl) countEl.textContent = displayCount + ' reviews';

      // Calculate distribution from actual reviews
      var dist = {};
      for (var r = 1; r <= 5; r++) dist[r] = 0;
      reviews.forEach(function(rev) {
        var rating = rev.rating || 5;
        dist[rating] = (dist[rating] || 0) + 1;
      });

      // Scale distribution to match displayCount
      var actualTotal = reviews.length;
      var scale = actualTotal > 0 && displayCount > actualTotal ? displayCount / actualTotal : 1;

      // Update distribution bars
      for (var s = 1; s <= 5; s++) {
        var rawCount = dist[s] || 0;
        var pct = actualTotal > 0 ? Math.round(rawCount / actualTotal * 100) : 0;
        var bar = document.querySelector('.bar-' + s);
        if (bar) bar.style.width = pct + '%';
        var pctEl = document.querySelector('.pct-' + s);
        if (pctEl) pctEl.textContent = pct + '%';
      }
    }, 100);
  }

  // PAGINATE EXISTING LIQUID REVIEWS
  // When the Liquid template renders reviews without pagination,
  // this function takes over and adds 10-per-page pagination
  var liquidReviewsData = [];
  var liquidPage = 1;
  var LIQUID_PER_PAGE = 10;

  function paginateLiquidReviews(reviews) {
    liquidReviewsData = reviews;
    liquidPage = 1;

    // Wait for the Liquid inline script to finish rendering reviews
    var checkCount = 0;
    var checkInterval = setInterval(function() {
      checkCount++;
      var listEl = document.getElementById('alireviews-list');
      var loadingEl = document.getElementById('alireviews-loading');
      // Check if loading is done (loading element removed or list has review content)
      if (listEl && (!loadingEl || listEl.children.length > 1 || listEl.innerHTML.indexOf('border-bottom') > -1)) {
        clearInterval(checkInterval);
        renderLiquidPage(1);
      }
      if (checkCount > 100) clearInterval(checkInterval); // 10 second timeout
    }, 100);
  }

  function liquidRenderReview(r) {
    var name = r.name || r.reviewerName || r.author || 'Anonymous';
    var rating = r.rating || 5;
    var text = r.body || r.content || r.text || '';
    var date = r.date || r.createdAt || '';
    var verified = r.source === 'aliexpress' || r.verified !== false;
    var images = r.images || [];
    var colors = [
      'linear-gradient(135deg, #6366f1, #8b5cf6)',
      'linear-gradient(135deg, #ec4899, #f472b6)',
      'linear-gradient(135deg, #10b981, #34d399)',
      'linear-gradient(135deg, #f59e0b, #fbbf24)',
      'linear-gradient(135deg, #3b82f6, #60a5fa)',
      'linear-gradient(135deg, #ef4444, #f87171)'
    ];
    var hash = 0;
    for (var i = 0; i < name.length; i++) hash = name.charCodeAt(i) + ((hash << 5) - hash);
    var bgColor = colors[Math.abs(hash) % colors.length];
    var parts = name.trim().split(' ');
    var initials = parts.length >= 2 ? (parts[0][0] + parts[parts.length-1][0]).toUpperCase() : name.substring(0,2).toUpperCase();
    var stars = '';
    for (var s = 1; s <= 5; s++) stars += s <= rating ? '\u2605' : '\u2606';

    var html = '<div style="padding: 20px 0; border-bottom: 1px solid #e5e7eb;">';
    html += '<div style="display: flex; justify-content: space-between; align-items: flex-start; margin-bottom: 12px;">';
    html += '<div style="display: flex; align-items: center; gap: 12px;">';
    html += '<div style="width: 44px; height: 44px; background: ' + bgColor + '; border-radius: 50%; display: flex; align-items: center; justify-content: center; color: white; font-weight: 600; font-size: 16px;">' + initials + '</div>';
    html += '<div>';
    html += '<div style="font-weight: 600; font-size: 16px; color: #111;">' + name + '</div>';
    html += '<div style="color: #f59e0b; font-size: 15px;">' + stars + '</div>';
    html += '</div></div>';
    if (verified) {
      html += '<span style="font-size: 13px; color: #22c55e; background: #dcfce7; padding: 4px 10px; border-radius: 20px; font-weight: 500;">\u2713 Verified Buyer</span>';
    }
    html += '</div>';
    if (text) html += '<p style="font-size: 15px; color: #4b5563; line-height: 1.7; margin: 0;">' + text + '</p>';

    if (images.length > 0) {
      html += '<div style="display: flex; gap: 8px; margin-top: 12px; flex-wrap: wrap;">';
      images.forEach(function(img) {
        html += '<img src="' + img + '" style="width: 80px; height: 80px; object-fit: cover; border-radius: 8px; cursor: pointer;" onclick="window.digifiyOpenImage ? window.digifiyOpenImage(this.src) : window.open(this.src)">';
      });
      html += '</div>';
    }

    if (date) html += '<div style="font-size: 13px; color: #9ca3af; margin-top: 10px;">' + date + '</div>';
    html += '</div>';
    return html;
  }

  function renderLiquidPage(page) {
    var total = liquidReviewsData.length;
    var totalPages = Math.ceil(total / LIQUID_PER_PAGE);
    if (page < 1) page = 1;
    if (page > totalPages) page = totalPages;
    liquidPage = page;

    var start = (page - 1) * LIQUID_PER_PAGE;
    var end = Math.min(start + LIQUID_PER_PAGE, total);
    var pageReviews = liquidReviewsData.slice(start, end);

    var listEl = document.getElementById('alireviews-list');
    if (!listEl) return;

    var html = '';
    pageReviews.forEach(function(r) {
      html += liquidRenderReview(r);
    });

    listEl.innerHTML = html;

    // Render pagination controls
    var pagEl = document.getElementById('alireviews-pagination');
    if (!pagEl) {
      pagEl = document.createElement('div');
      pagEl.id = 'alireviews-pagination';
      listEl.parentNode.insertBefore(pagEl, listEl.nextSibling);
    }

    if (totalPages <= 1) {
      pagEl.style.display = 'none';
      return;
    }

    pagEl.style.display = 'block';
    var pHtml = '<div style="display:flex;align-items:center;justify-content:center;gap:6px;margin-top:24px;padding-top:20px;border-top:1px solid #e5e7eb;flex-wrap:wrap;">';
    pHtml += '<button onclick="window._dPag(' + (page-1) + ')" style="background:#fff;border:1px solid #d1d5db;padding:8px 14px;font-size:14px;color:#374151;cursor:pointer;border-radius:8px;font-weight:500;' + (page === 1 ? 'opacity:0.4;cursor:not-allowed;' : '') + '"' + (page === 1 ? ' disabled' : '') + '>&lsaquo; Prev</button>';
    for (var i = 1; i <= totalPages; i++) {
      if (totalPages <= 7 || i === 1 || i === totalPages || Math.abs(i - page) <= 1) {
        pHtml += '<button onclick="window._dPag(' + i + ')" style="background:' + (i === page ? '#111;color:#fff;border-color:#111;' : '#fff;color:#374151;border-color:#d1d5db;') + 'border:1px solid;padding:8px 14px;font-size:14px;cursor:pointer;border-radius:8px;font-weight:500;">' + i + '</button>';
      } else if ((i === 2 && page > 4) || (i === totalPages - 1 && page < totalPages - 3)) {
        pHtml += '<span style="color:#9ca3af;font-size:14px;padding:0 4px;">...</span>';
      }
    }
    pHtml += '<button onclick="window._dPag(' + (page+1) + ')" style="background:#fff;border:1px solid #d1d5db;padding:8px 14px;font-size:14px;color:#374151;cursor:pointer;border-radius:8px;font-weight:500;' + (page === totalPages ? 'opacity:0.4;cursor:not-allowed;' : '') + '"' + (page === totalPages ? ' disabled' : '') + '>Next &rsaquo;</button>';
    pHtml += '<span style="font-size:13px;color:#9ca3af;margin-left:8px;">' + (start+1) + '-' + end + ' of ' + total + '</span>';
    pHtml += '</div>';
    pagEl.innerHTML = pHtml;
  }

  window._dPag = function(page) {
    var totalPages = Math.ceil(liquidReviewsData.length / LIQUID_PER_PAGE);
    if (page < 1 || page > totalPages) return;
    renderLiquidPage(page);
    var section = document.getElementById('digifiy-reviews-section');
    if (section) section.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  // MAIN INIT
  function init() {
    if (!isProductPage()) return;

    console.log('[Digifiy Boost] Initializing v1.3 with real reviews...');

    // Fix variant price: instant update from pre-loaded variant data.
    // Uses event delegation (survives DOM replacement) + MutationObserver
    // (fixes price after theme swaps section HTML from CDN cache).
    (function fixVariantPrice() {
      var pi = document.querySelector('product-info');
      if (!pi) return;
      var sid = pi.dataset.section;
      if (!sid) return;
      var priceId = 'price-' + sid;

      // Add price ID so theme's updateSourceFromDestination('price') works
      if (!document.getElementById(priceId)) {
        var priceDiv = pi.querySelector('product-price .price');
        if (!priceDiv) priceDiv = pi.querySelector('.price');
        if (priceDiv) priceDiv.id = priceId;
      }

      // Shopify's web-pixel loader script also contains a "variants" array where price is an
      // OBJECT {amount: 33.99, currencyCode: "USD"} (not cents) — normalise both shapes to cents.
      function toCents(p) {
        if (p && typeof p === 'object') return Math.round(parseFloat(p.amount) * 100);
        return Number(p);
      }
      function money(cents) {
        var c = toCents(cents);
        if (!isFinite(c) || c <= 0) return null;
        return '$' + (c / 100).toFixed(2) + ' USD';
      }

      // Build variant lookup from product JSON embedded in page
      var allVariants = [];
      var variantsByTitle = {};
      try {
        var scripts = document.querySelectorAll('script:not([src])');
        for (var i = 0; i < scripts.length; i++) {
          var txt = scripts[i].textContent;
          var m = txt.match(/"variants"\s*:\s*\[/);
          if (m && txt.indexOf('"price"') !== -1) {
            var start = m.index + '"variants":'.length;
            var depth = 0;
            for (var j = start; j < txt.length; j++) {
              if (txt[j] === '[') depth++;
              if (txt[j] === ']') depth--;
              if (depth === 0) {
                allVariants = JSON.parse(txt.substring(start, j + 1));
                break;
              }
            }
            if (allVariants.length) break;
          }
        }
        allVariants.forEach(function(v) {
          if (v.public_title) variantsByTitle[v.public_title] = v;
          if (v.option1) variantsByTitle[v.option1] = v;
          if (v.title) variantsByTitle[v.title] = v;
        });
      } catch(e) {}

      // Find variant from currently checked radios/selects
      function getSelectedVariant() {
        var opts = [];
        pi.querySelectorAll('variant-selects input[type="radio"]:checked, variant-radios input[type="radio"]:checked').forEach(function(r) { opts.push(r.value); });
        pi.querySelectorAll('variant-selects select, variant-radios select').forEach(function(s) { opts.push(s.value); });
        if (!opts.length) return null;
        var matched = variantsByTitle[opts[0]];
        if (!matched) {
          for (var i = 0; i < allVariants.length; i++) {
            var v = allVariants[i];
            if ((v.option1 === opts[0] || v.public_title === opts[0]) &&
                (!opts[1] || v.option2 === opts[1]) &&
                (!opts[2] || v.option3 === opts[2])) {
              matched = v;
              break;
            }
          }
        }
        return matched;
      }

      // Update DOM price elements
      function updatePriceDOM(v) {
        if (!v || !v.price) return;
        var priceTxt = money(v.price);
        if (!priceTxt) return; // unparseable price → keep the Liquid-rendered price, never show $NaN
        var el = document.getElementById(priceId);
        if (!el) el = pi.querySelector('.price');
        if (!el) return;
        var pn = el.querySelector('.price-now');
        if (pn) pn.textContent = priceTxt;
        var pr = el.querySelector('.price-item--regular');
        if (pr) pr.textContent = priceTxt;
        // Only update compare/sale elements if variant has compare_at_price data.
        // If undefined/null, leave Liquid-rendered content untouched.
        if (typeof v.compare_at_price === 'undefined' || v.compare_at_price === null) return;
        var pc = toCents(v.price), cc = toCents(v.compare_at_price);
        if (cc > pc) {
          el.classList.add('price--on-sale');
          var pw = el.querySelector('.price-was');
          if (pw && money(cc)) pw.textContent = money(cc);
          var po = el.querySelector('.price-off');
          if (po) po.textContent = Math.round((cc - pc) / cc * 100) + '% OFF';
        } else {
          el.classList.remove('price--on-sale');
          var pw2 = el.querySelector('.price-was');
          if (pw2) pw2.textContent = '';
          var po2 = el.querySelector('.price-off');
          if (po2) po2.textContent = '';
        }
      }

      // 1. INSTANT price update via event delegation on product-info
      //    (survives variant-selects DOM replacement by theme)
      if (allVariants.length) {
        pi.addEventListener('change', function(e) {
          if (e.target.matches('variant-selects input[type="radio"], variant-radios input[type="radio"], variant-selects select, variant-radios select')) {
            var v = getSelectedVariant();
            if (v) updatePriceDOM(v);
          }
        });
      }

      // 2. MutationObserver: fix price after theme's section rendering
      //    swaps innerHTML (may contain stale CDN-cached prices).
      //    Only observe childList (not characterData/subtree) so our
      //    textContent updates don't re-trigger the observer.
      var priceContainer = document.getElementById(priceId);
      if (priceContainer && allVariants.length) {
        var observer = new MutationObserver(function() {
          observer.disconnect();
          var v = getSelectedVariant();
          if (v) updatePriceDOM(v);
          setTimeout(function() {
            observer.observe(priceContainer, { childList: true });
          }, 50);
        });
        observer.observe(priceContainer, { childList: true });
      }

      // 3. Minimal fetch interceptor: only ensure price ID exists in response
      //    (no content manipulation — MutationObserver handles price fixing)
      var origFetch = window.fetch;
      window.fetch = function() {
        var url = arguments[0];
        var urlStr = typeof url === 'string' ? url : (url && url.url ? url.url : '');
        if (urlStr.indexOf('section_id=') === -1) {
          return origFetch.apply(this, arguments);
        }
        return origFetch.apply(this, arguments).then(function(response) {
          if (!response.ok) return response;
          return response.text().then(function(text) {
            // Only inject price ID if missing (for theme's updateSourceFromDestination)
            if (text.indexOf('id="' + priceId + '"') === -1) {
              var ppIdx = text.indexOf('<product-price');
              if (ppIdx !== -1) {
                var priceIdx = text.indexOf('class="price', ppIdx);
                if (priceIdx !== -1) {
                  var tagEnd = text.indexOf('>', priceIdx);
                  if (tagEnd !== -1) {
                    text = text.substring(0, tagEnd) + ' id="' + priceId + '"' + text.substring(tagEnd);
                  }
                }
              }
            }
            return new Response(text, {
              status: response.status,
              statusText: response.statusText,
              headers: response.headers
            });
          });
        });
      };

      // Fix initial price on page load (CDN may serve stale "From $X" price)
      if (allVariants.length) {
        var v = getSelectedVariant();
        if (v) updatePriceDOM(v);
      }
    })();

    waitFor('.product-details, .product-form, .product-information, [data-product-id]', function(container) {

      var titleEl = container.querySelector('h1, .product__title, .product-title');
      var descEl = container.querySelector('.product__description, .product-description, [data-product-description], .rte');
      var priceEl = container.querySelector('.price, .product-price, .product__price');
      var formEl = container.querySelector('form, .product-form');
      var variantEl = container.querySelector('variant-selects, variant-radios, .product-form__input, [data-variant-id]');

      var productId = getProductId();
      console.log('[Digifiy Boost] Product ID:', productId);

      // If no product ID found, retry after a delay (ShopifyAnalytics might not be ready)
      if (!productId) {
        console.log('[Digifiy Boost] No product ID yet, retrying in 150ms...');
        setTimeout(function() {
          productId = getProductId();
          console.log('[Digifiy Boost] Retry Product ID:', productId);
          if (productId) {
            loadReviews(productId);
          } else {
            console.log('[Digifiy Boost] Could not find product ID');
          }
        }, 150);
        return;
      }

      function loadReviews(pid) {
        fetchRealReviews(pid, processReviews);
      }

      function processReviews(data) {
        var reviews = data.reviews || [];
        var stats = data.stats || {};
        var isFake = false;
        var displayCount; // the count shown in stars/summary (may differ from reviews.length for fakes)

        // If no real reviews, use fake reviews
        if (reviews.length === 0 && productId) {
          var fakeData = getFakeReviewData(productId);
          reviews = fakeData.reviews;
          stats = fakeData.stats;
          displayCount = fakeData.fakeCount;
          isFake = true;
          console.log('[Digifiy Boost] No real reviews - using set', hashProductId(productId) % 5, 'with', displayCount, 'displayed count');
        } else {
          displayCount = reviews.length;
        }

        var rating = stats.avgRating || 4.9;
        var reviewCount = displayCount;

        console.log('[Digifiy Boost] Loaded', reviews.length, isFake ? 'fake' : 'real', 'reviews, display count:', reviewCount);

        // Check if Liquid templates already handle reviews & urgency
        var hasLiquidReviews = document.querySelector('.digifiy-reviews-section, #digifiy-reviews-section, #alireviews-list');
        var hasLiquidStars = document.querySelector('.digifiy-review-stars');
        var hasLiquidUrgency = document.querySelector('.digifiy-urgency-inline');

        // 1. Reviews summary after title - only if Liquid hasn't already rendered it
        if (titleEl && !hasLiquidStars) {
          var reviewsSummary = document.createElement('div');
          reviewsSummary.innerHTML = createReviewsSummary(rating, reviewCount);
          titleEl.parentNode.insertBefore(reviewsSummary.firstElementChild, titleEl.nextSibling);
        }

        // 2. REORDER ELEMENTS: Price + Countdown + Urgency - only if Liquid hasn't already rendered them
        if (!hasLiquidUrgency) {
          var reviewsSummaryEl = document.querySelector('.digifiy-reviews-summary');
          var insertAfter = reviewsSummaryEl || titleEl;

          if (insertAfter) {
            // Move theme's PRICE right after reviews
            if (priceEl) {
              insertAfter.parentNode.insertBefore(priceEl, insertAfter.nextSibling);
              insertAfter = priceEl;
            }

            // Insert COUNTDOWN right after price
            var countdown = document.createElement('div');
            countdown.innerHTML = createCountdown();
            if (countdown.firstElementChild) {
              insertAfter.parentNode.insertBefore(countdown.firstElementChild, insertAfter.nextSibling);
              insertAfter = countdown.firstElementChild || insertAfter.nextSibling;
            }

            // Insert URGENCY BAR (Free Shipping + Viewers) after countdown
            var urgencyTop = document.createElement('div');
            urgencyTop.className = 'digifiy-urgency-top';
            urgencyTop.innerHTML = createUrgencyBar() + createViewersCounter();
            var countdownEl = document.querySelector('.digifiy-countdown');
            if (countdownEl) {
              countdownEl.parentNode.insertBefore(urgencyTop, countdownEl.nextSibling);
            } else if (insertAfter && insertAfter.nextSibling) {
              insertAfter.parentNode.insertBefore(urgencyTop, insertAfter.nextSibling);
            }
          }
        }

        // 4. Bulk Discount
        if (formEl && formEl.parentNode) {
          var bulkDiscount = document.createElement('div');
          bulkDiscount.innerHTML = createBulkDiscount();
          if (bulkDiscount.firstElementChild) {
            formEl.parentNode.insertBefore(bulkDiscount.firstElementChild, formEl.nextSibling);
          }
        }

        // 5. Trust badges + Payment icons + Guarantee + Benefits
        // Only add if Liquid template hasn't already rendered them
        var hasLiquidTrust = document.querySelector('.digifiy-trust-badges, .digifiy-payment-badges');
        if (formEl && formEl.parentNode && !hasLiquidTrust) {
          var trustSection = document.createElement('div');
          trustSection.className = 'digifiy-trust-section';
          trustSection.innerHTML = createTrustBadges() + createPaymentIcons() + createGuarantee() + createBenefits();
          var bulkCard = document.querySelector('.digifiy-bulk-discount');
          if (bulkCard && bulkCard.parentNode) {
            bulkCard.parentNode.insertBefore(trustSection, bulkCard.nextSibling);
          } else {
            formEl.parentNode.insertBefore(trustSection, formEl.nextSibling);
          }
        }

        // 6. Professional Tabs with reviews - only if Liquid hasn't already rendered the reviews section
        if (!hasLiquidReviews) {
          var existingDesc = document.querySelector('.product__description, .product-description, .rte.product__text, [data-product-description], .product-single__description, .product__text, .rte');
          var descriptionContent = existingDesc ? existingDesc.innerHTML : '<p>Premium quality product with excellent features.</p>';

          var tabsSection = document.createElement('div');
          tabsSection.innerHTML = createProductTabs(descriptionContent, reviews, stats, reviewCount);

          var productSection = document.querySelector('.product-details, .product-information, .product__info-container');
          if (productSection && productSection.parentNode) {
            productSection.parentNode.insertBefore(tabsSection.firstElementChild, productSection.nextSibling);
          }

          setTimeout(function() {
            initTabs();
            renderStorefrontReviewsPage();
          }, 100);
        } else {
          console.log('[Digifiy Boost] Liquid reviews section found - adding pagination to existing reviews');

          // Update the Liquid star rating with real data (rating + count)
          if (hasLiquidStars) {
            // Update rating number - try new class first, then find by style/content
            var starsRatingEl = hasLiquidStars.querySelector('.digifiy-stars-rating');
            if (!starsRatingEl) {
              // Old template: find the span with hardcoded rating (e.g. "4.9")
              var spans = hasLiquidStars.querySelectorAll('span');
              for (var si = 0; si < spans.length; si++) {
                var txt = spans[si].textContent.trim();
                if (/^\d\.\d$/.test(txt)) { starsRatingEl = spans[si]; break; }
              }
            }
            if (starsRatingEl) starsRatingEl.textContent = reviewCount > 0 ? rating.toFixed(1) : '';

            // Update review count link
            var starsLink = hasLiquidStars.querySelector('.digifiy-stars-link, a');
            if (starsLink) starsLink.textContent = reviewCount > 0 ? '(' + reviewCount + ' reviews)' : '';

            // Hide entire stars section if no reviews
            if (reviewCount === 0) {
              hasLiquidStars.style.display = 'none';
            }
          }

          // Update the Liquid "Customer Reviews" summary header
          // (avg rating, stars, count, distribution bars)
          updateLiquidReviewsHeader(rating, reviewCount, reviews);

          // Hijack the Liquid inline script's review rendering by adding pagination
          // Wait for the inline script to finish loading reviews, then paginate them
          paginateLiquidReviews(reviews);
        }

        // Mark container as loaded (removes skeleton)
        container.classList.add('digifiy-loaded');
      }

      // Fetch real reviews
      fetchRealReviews(productId, processReviews);

      // Sticky cart and social proof
      document.body.insertAdjacentHTML('beforeend', createStickyCart());
      document.body.insertAdjacentHTML('beforeend', createSocialProof());

      // Image lightbox modal
      document.body.insertAdjacentHTML('beforeend',
        '<div class="digifiy-image-modal" id="digifiy-image-modal" onclick="window.digifiyCloseImage()">' +
          '<img src="" alt="Review image" id="digifiy-modal-img">' +
          '<button class="digifiy-modal-close" onclick="window.digifiyCloseImage()">×</button>' +
        '</div>' +
        '<style>' +
          '.digifiy-image-modal{display:none;position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(0,0,0,0.92);z-index:99999;justify-content:center;align-items:center;padding:20px;box-sizing:border-box;}' +
          '.digifiy-image-modal.active{display:flex;}' +
          '.digifiy-image-modal img{max-width:90%;max-height:90%;border-radius:8px;box-shadow:0 4px 30px rgba(0,0,0,0.5);object-fit:contain;}' +
          '.digifiy-modal-close{position:absolute;top:20px;right:20px;width:44px;height:44px;border:none;background:#fff;color:#222;font-size:28px;border-radius:50%;cursor:pointer;display:flex;align-items:center;justify-content:center;box-shadow:0 2px 10px rgba(0,0,0,0.3);}' +
          '.digifiy-modal-close:hover{background:#f5f5f5;}' +
          '.digifiy-review-images{display:flex;gap:8px;flex-wrap:wrap;margin-top:12px;}' +
          '.digifiy-review-img{width:70px;height:70px;object-fit:cover;border-radius:8px;cursor:pointer;transition:transform 0.2s,box-shadow 0.2s;}' +
          '.digifiy-review-img:hover{transform:scale(1.05);box-shadow:0 4px 12px rgba(0,0,0,0.15);}' +
          '.digifiy-more-images{width:70px;height:70px;background:rgba(0,0,0,0.7);color:#fff;border-radius:8px;display:flex;align-items:center;justify-content:center;font-weight:600;font-size:14px;}' +
          /* Reviews Section Styles */
          '.digifiy-reviews-header{display:flex;gap:40px;padding:25px;background:linear-gradient(135deg,#fafafa 0%,#f5f5f5 100%);border-radius:16px;margin-bottom:25px;flex-wrap:wrap;align-items:center;}' +
          '.digifiy-reviews-avg{display:flex;align-items:center;gap:15px;}' +
          '.digifiy-reviews-score{font-size:56px;font-weight:700;color:#222;line-height:1;}' +
          '.digifiy-reviews-stars{font-size:22px;color:#ffc107;letter-spacing:2px;}' +
          '.digifiy-reviews-count{font-size:14px;color:#666;margin-top:4px;}' +
          '.digifiy-rating-bars{flex:1;min-width:250px;max-width:350px;}' +
          '.digifiy-rating-bar{display:flex;align-items:center;gap:10px;margin-bottom:8px;}' +
          '.digifiy-bar-label{width:40px;font-size:13px;color:#666;font-weight:500;}' +
          '.digifiy-bar-track{flex:1;height:10px;background:#e5e5e5;border-radius:5px;overflow:hidden;}' +
          '.digifiy-bar-fill{height:100%;background:linear-gradient(90deg,#ffc107 0%,#ffca28 100%);border-radius:5px;transition:width 0.5s ease;}' +
          '.digifiy-bar-count{width:30px;font-size:13px;color:#888;text-align:right;}' +
          '.digifiy-reviews-list{display:flex;flex-direction:column;gap:16px;}' +
          '.digifiy-review-item{background:#fff;border:1px solid #eee;border-radius:12px;padding:20px;transition:box-shadow 0.2s;}' +
          '.digifiy-review-item:hover{box-shadow:0 4px 15px rgba(0,0,0,0.08);}' +
          '.digifiy-review-header{display:flex;align-items:center;gap:12px;margin-bottom:12px;flex-wrap:wrap;}' +
          '.digifiy-review-avatar{width:44px;height:44px;border-radius:50%;background:linear-gradient(135deg,#667eea 0%,#764ba2 100%);color:#fff;display:flex;align-items:center;justify-content:center;font-weight:600;font-size:18px;flex-shrink:0;}' +
          '.digifiy-review-meta{flex:1;min-width:120px;}' +
          '.digifiy-review-name{font-weight:600;color:#222;font-size:15px;}' +
          '.digifiy-review-date{font-size:12px;color:#888;margin-top:2px;}' +
          '.digifiy-review-rating{font-size:16px;color:#ffc107;letter-spacing:1px;}' +
          '.digifiy-review-verified{font-size:11px;color:#00a67c;background:#e8f8f3;padding:4px 10px;border-radius:20px;font-weight:500;}' +
          '.digifiy-review-text{color:#444;line-height:1.7;font-size:14px;margin:12px 0;}' +
          '.digifiy-review-sku{font-size:12px;color:#888;padding-top:12px;margin-top:12px;border-top:1px solid #f0f0f0;}' +
          '.digifiy-no-reviews{text-align:center;padding:40px 20px;color:#888;font-size:15px;}' +
          /* Pagination Styles */
          '.digifiy-pagination{display:flex;align-items:center;justify-content:center;gap:6px;margin-top:24px;padding-top:20px;border-top:1px solid #eee;flex-wrap:wrap;}' +
          '.digifiy-page-btn{background:#fff;border:1px solid #ddd;padding:8px 14px;font-size:14px;color:#444;cursor:pointer;border-radius:8px;transition:all 0.2s;font-weight:500;}' +
          '.digifiy-page-btn:hover:not(:disabled){background:#f8f9fa;border-color:#222;color:#222;}' +
          '.digifiy-page-btn.active{background:#222;color:#fff;border-color:#222;}' +
          '.digifiy-page-btn:disabled{opacity:0.4;cursor:not-allowed;}' +
          '.digifiy-page-dots{color:#888;font-size:14px;padding:0 4px;}' +
          '.digifiy-page-info{font-size:13px;color:#888;margin-left:8px;}' +
          /* Tabs Styles */
          '.digifiy-tabs-container{margin-top:40px;border-top:1px solid #eee;padding-top:30px;}' +
          '.digifiy-tabs-header{display:flex;gap:8px;border-bottom:2px solid #eee;padding-bottom:0;margin-bottom:25px;flex-wrap:wrap;}' +
          '.digifiy-tab-btn{background:none;border:none;padding:12px 20px;font-size:15px;font-weight:500;color:#666;cursor:pointer;border-bottom:2px solid transparent;margin-bottom:-2px;transition:all 0.2s;display:flex;align-items:center;gap:8px;}' +
          '.digifiy-tab-btn:hover{color:#222;}' +
          '.digifiy-tab-btn.active{color:#222;border-bottom-color:#222;}' +
          '.digifiy-tab-btn .tab-icon{font-size:16px;}' +
          '.digifiy-tab-content{display:none;}' +
          '.digifiy-tab-content.active{display:block;}' +
        '</style>'
      );

      // Image modal functions
      window.digifiyOpenImage = function(src) {
        var modal = document.getElementById('digifiy-image-modal');
        var img = document.getElementById('digifiy-modal-img');
        if (modal && img) {
          img.src = src;
          modal.classList.add('active');
          document.body.style.overflow = 'hidden';
        }
      };

      window.digifiyCloseImage = function() {
        var modal = document.getElementById('digifiy-image-modal');
        if (modal) {
          modal.classList.remove('active');
          document.body.style.overflow = '';
        }
      };

      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape') window.digifiyCloseImage();
      });

      setTimeout(handleStickyCart, 1000);
      setInterval(updateCountdown, 1000);
      updateCountdown();
      setInterval(updateViewers, 8000);
      setTimeout(function() {
        showSocialProof();
        setInterval(showSocialProof, CONFIG.socialProofInterval);
      }, 5000);

      // Block reordering is now handled in processReviews function

      console.log('[Digifiy Boost] Loaded!');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();

/* cb-sticky-sync (2026-10-03): keep the sticky bar price in step with the selected variant, and measure the mobile
   toolbar / sticky bar heights so CSS can stack them (see cb-mobile-sticky-fix in digifiy-product-boost.css). */
(function() {
  function currentPrice() {
    var p = document.querySelector('product-info product-price');
    if (!p) return '';
    var els = p.querySelectorAll('.price-now, .price__sale .price-item--sale, .price-item--regular');
    for (var i = 0; i < els.length; i++) {
      if (els[i].offsetParent !== null && els[i].textContent.trim()) return els[i].textContent.trim();
    }
    return '';
  }
  function tick() {
    var root = document.documentElement;
    var tb = document.querySelector('toolbar-mobile');
    var tbH = (tb && getComputedStyle(tb).display !== 'none') ? tb.offsetHeight : 0;
    root.style.setProperty('--dgf-toolbar-h', tbH + 'px');
    var s = document.getElementById('digifiy-sticky-cart');
    if (!s) return;
    root.style.setProperty('--dgf-sticky-h', s.offsetHeight + 'px');
    document.body.classList.toggle('dgf-sticky-on', s.classList.contains('visible'));
    var el = s.querySelector('.digifiy-sticky-cart-price');
    var t = currentPrice();
    if (el && t && el.textContent !== t) el.textContent = t;
  }
  function start() {
    if (!document.querySelector('product-info')) return;
    tick();
    new MutationObserver(tick).observe(document.querySelector('product-info'), { childList: true, subtree: true, characterData: true });
    setInterval(tick, 1000);
    window.addEventListener('resize', tick);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
